// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1ovCJ","tab":"ProcedureTabs_tab__2Eg9Y"};